import dynamic from "next/dynamic";
const ElectionPage = dynamic(() => import("@/screens/FiveStateElection"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));

import { getDataByUrl } from "@/handlers/commonApi";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import useIsMobile from "@/hooks/useIsMobile";

import { useContext } from "react";

export default function ElectionTab({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  electionCategory = null,
  constituencyListData = null,
}) {
  const masterConfig = useContext(MasterConfigContext);
  const biharElectionKey = masterConfig["kerala_election"];
  const resultYear = biharElectionKey?.resultYear;
  const isMobileDevice = useIsMobile();
  const oldResult = {
    partyData: [
      {
        color: "#FF9933",
        partyName: "LDF",
        partySeat: "97",
      },
      {
        color: "#19AAED",
        partyName: "UDF",
        partySeat: "41",
      },
      {
        color: "#19AAED",
        partyName: "BJP+",
        partySeat: "0",
      },
       
      {
        color: "#CC0000",
        partyName: "OTH",
        partySeat: "2",
      },
    ],
  };
  const oldDesc =`Kerala Assembly Elections Results 2026: केरल में इस बार 140 विधानसभा सीटों पर एक ही चरण में मतदान होना है. साल 2021 के विधानसभा चुनाव में केरल में LDF (वाम लोकतांत्रिक मोर्चा...जिसमें CPI(M), CPI, केरल कांग्रेस M, NCP शामिल थे) ने 99 सीटों पर जीत हासिल कर सरकार बनाई थी. UDF यानी (संयुक्त लोकतांत्रिक मोर्चा...जिसमें कांग्रेस (INC), IUML, केरल कांग्रेस) 41 सीटें ही हासिल कर पाई और विपक्ष में बैठी. केरल में NDA (BJP, BDJS) का सुपड़ा साफ हो गया. ये एक भी सीट नहीं जीत पाए. इस बार मुख्यमंत्री पिनाराई विजयन के नेतृत्व में  LDF 'हैट्रिक' लगाने के इरादे से मैदान में है. कांग्रेस के नेतृत्व वाला यह विपक्षी गठबंधन UDF सत्ता में वापसी की कोशिश कर रहा है. अब देखना ये है कि केरल में कमल खिलेगा या कांग्रेस पार्टी के नेतृत्व वाला गठबंधन बाजी मारेगा या इन सबको फिर फिछे धकेलते हुए वाम दल अपना वर्चस्व कायम रखेंगे. 4 मई को सब पता चल जाएगा.`
  const newDesc = oldDesc
  // const newDesc = `Kerala Assembly Elections Results 2025: इस बार के केरल विधानसभा चुनाव में कौन मारेगा बाजी? NDA या महागठबंधन...किसको मिलेगा बहुमत? BJP के साथ मिलकर JDU कर पाएगा कमाल या RJD और कांग्रेस की जोड़ी में VIP और लेफ्ट पार्टी मिल पलट देंगी गेम? नीतीश की बनेगी सरकार या प्रशांत किशोर की भविष्यवाणी होगी सच?  सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ.`;

  let metaData = {
    title: `Kerala Assembly Chunav  ${resultYear} Results: केरल विधानसभा चुनाव रिजल्ट  ${resultYear} जानें सभी सीटों के नतीजे - NewsTak`,
    description: `Kerala Assembly Election  ${resultYear} Results: केरल विधानसभा चुनाव  ${resultYear} के सभी सीटों के ताज़ा नतीजे और जीत-हार के आंकड़े देखें। जानें किस पार्टी को कितनी सीटें मिलीं और कौन बना रहा है सरकार — लाइव अपडेट्स के साथ।`,
    keywords: `केरल विधानसभा चुनाव ${resultYear} परिणाम, Kerala Assembly Election ${resultYear} Results, Kerala Chunav Result ${resultYear}, Kerala Election Result Live, Kerala Vidhan Sabha Result, Kerala Election Seat Wise Result, केरल सीटवार चुनाव नतीजे, Kerala Election Winner List, केरल चुनाव वोट गिनती, Kerala Assembly Election Live Updates, किसे कितनी सीटें मिली केरल चुनाव, Kerala Election Final Result ${resultYear}`,
  };

  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
      >
        <ElectionPage
          categoryNewsListData={categoryNewsListData}
          // faqData={faqData}

          electionPath={`${electionCategory}/results`}
          isMobileDevice={isMobileDevice}
         
          electionPassedCategory={electionCategory} //'delhi-assembly'
          masterKey="kerala_election"
          stateName={"Kerala"} //"Delhi"
          stateHindi={"केरल"}
          metaData={metaData}
          oldResult={oldResult}
          oldDesc={oldDesc}
          newDesc={newDesc}
          resultKey={"partiesDataBR"}
          constituencyListData={constituencyListData}
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");

  let url = ctx?.resolvedUrl;
  url = url.split("/results")[0];

  let electionCategory = url.split("/elections/")[1];
 
  if (!electionCategory) {
    return {
      notFound: true,
    };
  }

  try {
    const { getLatestContentFeed } = await import("@/handlers/content");
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let masterConfigData = await getMasterConfig();

    let categoryListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: 0,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });
    let electionConfigData = null;
    const electionConfig = await fetch(
      `${
        process.env.BASE_PATH + process.env.API_PREFIX
      }/staticconfig?id=masterconfig`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (res) => {
      return await res.json();
    });
    electionConfigData = electionConfig?.data?.kerala_election;
    let constituencyListData = null;

    let constituencyUrl =
      electionConfigData?.constListYear == 2021
        ? electionConfigData?.allConstituency2021Api
        : electionConfigData?.allConstituency2026Api;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2020-all-consituency.json`;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const data1 = await data.json();
      // console.log("delhi-constitutency", data1);
      constituencyListData = data1; //electionConfigData?.constListYear==2020 ?  data1 : data1?.data;
    });
    let [
      categoryNewsListData,
      latestStoryData,
      latestVideoData,
      // , faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: 0,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryRedisKey, () =>
        getLatestContentFeed({
          type: "story",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(latestVideoRedisKey, () =>
        getLatestContentFeed({
          type: "video",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 120);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        electionCategory,
        constituencyListData,
        // faqData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
